jQuery( document ).ready(function( $ ) {
  
	$('.mmg-embed-preview').each(function() {
    const $this = $(this);
    const $button = $this.find('.mmg-embed-preview__refresh');
    const $status = $this.find('.mmg-embed-preview__status');
    const $iframe = $this.find('.mmg-embed-preview__iframe');
    const $http_referer = $this.find('.mmg-embed-preview__input');
    const $template = $('#content');
    const $css = $('#_mmg_attributes-css');
    const $contentBlocks = $("[name^='_mmg_content_blocks[']");
    const data = $this.data();
    let touched = false;

    // Handle content changes
    $template.on('change', () => touched = true);
    $css.on('change', () => touched = true);
    $contentBlocks.each(function() {
      $(this).on('change', () => touched = true);
    });

    const handleSubmit = event => {
      const contentBlocks = {};
      const postData = {
        template: $template.val(),
        css: $css.val(), 
      }

      event.preventDefault();

      $iframe.attr('src', null);
      $iframe.contents().find('body').html('');
      $status.text('Updating...');

      if($contentBlocks.length){
        $contentBlocks.each(function() {
          const $block = $(this);
          const name = $block.attr('id').replace('_mmg_content_blocks-', '');
          contentBlocks[name] = $block.val();
        });
        postData.content_blocks = contentBlocks;
      }

      if($http_referer.val()){
        postData.http_referer = $http_referer.val();
        postData.post_type = data.postType;
      } else {
        postData.post_id = data.postId;
      }

      $.ajax({
        method: "POST",
        url: data.apiUrl,
        data: postData,
      })
      .done(function(response) {
        $iframe.contents().find('body').html(response.rendered);
        $status.text('');
        if(touched) {
          $status.text('Unsaved');
        }
      })
      .fail(function(jqXHR, textStatus, errorThrown){
        console.log(jqXHR, textStatus, errorThrown)
        let status = 'Error';
        if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
          status += ': ' + jqXHR.responseJSON.message;
        } else if (errorThrown) {
          status += ': ' + errorThrown;
        }
        $status.text(status);
      });
    };

    $button.on('click', handleSubmit);
    $http_referer.on('keypress', function(event) {
      if (event.key == "Enter") {
        handleSubmit(event);
        return false;
      }
    });

  }); 
});
